import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StaffCard } from 'src/app/admin/models/staffCard';
import { StaffcardService } from 'src/app/admin/services/staffcard.service';

@Component({
  selector: 'app-delete-staffcard-modal',
  templateUrl: './delete-staffcard-modal.component.html',
  styleUrls: ['./delete-staffcard-modal.component.scss'],
})
export class DeleteStaffcardModalComponent implements OnInit {
  staffCard:StaffCard;

  constructor(private modalController: ModalController, private staffCardService: StaffcardService) { }

  ngOnInit() {}


  removeStaffCard() {
    this.staffCardService.deleteStaffCard(this.staffCard.id).subscribe(res => {
      this.staffCardService.getAllStaffCard({currentPage: 1, itemsPerPage: 100,
        enterQuery: '',  fullNameQuery: '',roomNameQuery:''});
      this.dismissModal();
    },(err) => {
      console.error(err);
    })
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}